import { render, staticRenderFns } from "./LocationProfile.vue?vue&type=template&id=62659964&scoped=true&"
import script from "./LocationProfile.vue?vue&type=script&lang=js&"
export * from "./LocationProfile.vue?vue&type=script&lang=js&"
import style0 from "./LocationProfile.vue?vue&type=style&index=0&id=62659964&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62659964",
  null
  
)

export default component.exports